import {
  GET_EVENTS_REQUEST,
  GET_EVENTS_FAILURE,
  GET_EVENTS_SUCCESS,
} from './types';

const getTimelineEvents = () => ({
  type: 'CALL_API',
  url: '/data/saker.json',
  types: [GET_EVENTS_REQUEST, GET_EVENTS_FAILURE, GET_EVENTS_SUCCESS],
});

export { getTimelineEvents };



// WEBPACK FOOTER //
// ./src/timeline/actions.js